import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CloudUploadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cloud_upload"}/>
}
